export const chartDatesListStyles = {};
export const flagIconHeight = '24';
